import sizes from './sizes'

export default {
  Navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '6vh',
  },
  logo: {
    marginRight: '15px',
    padding: '0 13px',
    fontSize: '22px',
    backgroundColor: '#eceff1',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    color: 'rgba(0,0,0,0.7)',
    '& a': {
      textDecoration: 'none',
      color: 'rgba(0,0,0,0.7)',
    },
    [sizes.down('xs')]: {
      display: 'none',
    },
  },
  slider: {
    display: 'inline-block',
    margin: '0 10px',
    width: '340px',
    '& .rc-slider-track': {
      backgroundColor: 'transparent',
    },
    '& .rc-slider-rail': {
      height: '8px',
    },
    '& .rc-slider-handle, .rc-slider-handle:active, .rc-slider-handle:focus, .rc-slider-handle:hover': {
      backgroundColor: 'green',
      outline: 'none',
      border: '2px solid green',
      boxShadow: 'none',
      width: '13px',
      height: '13px',
      marginLeft: '0',
      marginTop: '-3px',
    },
    [sizes.down('sm')]: {
      width: '150px',
    },
  },
  selectContainer: {
    marginLeft: 'auto',
    marginRight: '1rem',
  },
}
